export const getPwaShellState = () => {
  if (typeof window === "undefined") {
    return {
      isPwaShell: false,
      isIosStandalone: false,
      isAndroidStandalone: false,
    };
  }

  const isStandaloneMode =
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.matchMedia?.("(display-mode: fullscreen)")?.matches ||
    window.matchMedia?.("(display-mode: minimal-ui)")?.matches ||
    window.navigator?.standalone === true;

  const isIosStandalone = window.navigator?.standalone === true;
  const isAndroidStandalone =
    window.matchMedia?.("(display-mode: standalone)")?.matches || false;

  return {
    isPwaShell: Boolean(isStandaloneMode),
    isIosStandalone,
    isAndroidStandalone,
  };
};

export const getPwaSurfaceState = () => {
  if (typeof window === "undefined") {
    return {
      isMobileWeb: false,
      isDesktopWeb: false,
    };
  }

  const width = window.innerWidth || 0;
  const isMobileWidth = width < 1024;
  const isCoarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0 || isCoarsePointer;

  return {
    isMobileWeb: Boolean(isMobileWidth && isTouchDevice),
    isDesktopWeb: Boolean(width >= 1024 || !isTouchDevice),
  };
};

export const normalizeTier = (tier) =>
  String(tier || "explorer").toLowerCase();

export const isPlusOrHigher = (tier) =>
  ["plus", "pro", "elite"].includes(normalizeTier(tier));

export const getPwaInstallPlatform = () => {
  if (typeof window === "undefined") return "desktop";

  const ua = window.navigator?.userAgent || "";
  const isIos = /iphone|ipad|ipod/i.test(ua);
  const isAndroid = /android/i.test(ua);

  if (isIos) return "ios";
  if (isAndroid) return "android";
  return "desktop";
};
